export default __webpack_public_path__ + "static/media/bmw7.fec9929f.png";